// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Prueba de Penetración de Aplicaciones Web?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Prueba de Penetración de Aplicaciones Web, a menudo denominada prueba de penetración de aplicaciones web, es un proceso metódico y controlado diseñado para evaluar la seguridad de las aplicaciones web. Su objetivo principal es identificar y evaluar vulnerabilidades, debilidades y posibles puntos de entrada que podrían ser explotados por actores malintencionados.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Prueba de Penetración de Aplicaciones Web
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="my_location"
                title="Definición del Alcance"
                description="El alcance de la prueba de penetración de aplicaciones web se define meticulosamente para evaluar aplicaciones web específicas, sitios web o plataformas en línea. Esto asegura que las pruebas estén alineadas con los objetivos de seguridad de la organización."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="public"
                title="Simulaciones Realistas"
                description="Los evaluadores utilizan técnicas similares a las empleadas por atacantes genuinos, intentando explotar vulnerabilidades identificadas para obtener acceso no autorizado, manipular datos o interrumpir servicios."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="pentagon"
                title="Informes Exhaustivos"
                description="Después de las pruebas, las organizaciones reciben informes detallados que describen las vulnerabilidades identificadas, el impacto potencial de su explotación y recomendaciones para la mitigación y remediación."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="description"
                title="Guía de Remediación"
                description="Los evaluadores de penetración de aplicaciones web a menudo proporcionan orientación y apoyo a las organizaciones para abordar y remediar las vulnerabilidades identificadas, ayudando a mejorar la postura general de seguridad."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="analytics"
                title="Evaluación de Riesgos"
                description="Los resultados de la prueba de penetración de aplicaciones web ayudan a las organizaciones a evaluar sus riesgos y vulnerabilidades de seguridad. Cada hallazgo se clasifica por gravedad, permitiendo a las organizaciones priorizar los esfuerzos de remediación."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Prueba de Penetración de Aplicaciones Web?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="lock"
                title="Protección de Datos Sensibles"
                description="Ayuda a las organizaciones a salvaguardar datos sensibles almacenados o procesados por aplicaciones web, como información de clientes, detalles de pago y propiedad intelectual."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="folder_off"
                title="Prevención de Brechas de Datos"
                description="Al identificar y abordar vulnerabilidades antes de que los actores malintencionados puedan explotarlas, la prueba de penetración de aplicaciones web ayuda a prevenir brechas de datos y las consecuencias legales y de reputación relacionadas."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="360"
                title="Continuidad del Negocio"
                description="Asegurar la seguridad de las aplicaciones web es esencial para la continuidad del negocio, ya que las interrupciones o compromisos pueden resultar en pérdidas financieras y daños a la reputación de la organización."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="gavel"
                title="Cumplimiento y Garantía"
                description="Muchas industrias y organismos reguladores exigen evaluaciones de seguridad regulares, incluida la prueba de penetración de aplicaciones web, para demostrar el cumplimiento y la adherencia a las mejores prácticas de ciberseguridad."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Prueba de Penetración de Aplicaciones Web en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Prueba de Penetración de Aplicaciones Web es un componente crítico de una estrategia integral de ciberseguridad, especialmente en una era donde las aplicaciones web son fundamentales para las operaciones comerciales. Asegura que las plataformas en línea permanezcan resilientes ante amenazas y vulnerabilidades en evolución. Al invertir en servicios de prueba de penetración de aplicaciones web, las organizaciones pueden mantener la confianza en sus interfaces digitales y proteger datos sensibles en un mundo digital cada vez más interconectado.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;